module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/thumbs/3-29863c88b842dadf33cd7eb5b1070290.webp";